import { gql } from '@apollo/client'

export const LOCATIONS_TREE_UPDATE_MUTATION = gql`
  mutation LOCATIONS_TREE_UPDATE_MUTATION($locations: [LocationsTreeUpdateInput]!) {
      locationsTreeUpdate(locations: $locations) {
      ok
    }
  }
`

export const LOCATION_DELETE_MUTATION = gql`
  mutation LOCATION_DELETE_MUTATION($id: ID!) {
    locationDelete(id: $id) {
      ok
    }
  }
`

export const LOCATION_UPDATE_MUTATION = gql`
  mutation LOCATION_UPDATE_MUTATION($id: ID!, $location: LocationUpdateInput!) {
    locationUpdate(id: $id, location: $location) {
      ok
    }
  }
`

export const LOCATION_CREATE_MUTATION = gql`
  mutation LOCATION_CREATE_MUTATION($location: LocationCreateInput!) {
    locationCreate(location: $location) {
      ok
    }
  }
`
